module.exports = __webpack_public_path__ + "img/icon_date.ae12594f.svg";